import { ResetPassword } from '@/config/types';
import { apiLoginGA } from '@/services/api-config';

export default async function (payload: ResetPassword) {
  return apiLoginGA
    .post('password/change', payload)
    .then((response) => response.data)
    .catch((e) => e.response.data);
}
